import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import {Product} from '@/_application/modules/products/model/product';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {SwiperSlide} from 'swiper/react';
import ProductLoader from '@/_application/core/components/ui/loaders/product-loader';
import rangeMap from '@/lib/range-map';
interface IViewedProductsSwiperProps {
    data: Product[];
    isLoading?: boolean;
}

const productSwiperBreakpoints = {
    320: {
        slidesPerView: 2,
    },
    480: {
        slidesPerView: 3,
    },
    640: {
        slidesPerView: 3,
    },
    768: {
        slidesPerView: 3,
    },
    1024: {
        slidesPerView: 4,
    },
    1280: {
        slidesPerView: 5,
    },
};

function ViewedProductsSwiper({data, isLoading}: Readonly<IViewedProductsSwiperProps>) {
    return (
        <CustomSwiper
            className="mt-2 md:min-h-104"
            hasNavigation
            slidesPerView={4}
            spaceBetween={30}
            buttonPrevClassName="-left-6 h-11! w-11!"
            buttonNextClassName="-right-6 h-11! w-11!"
            breakpoints={productSwiperBreakpoints}
            data={data as any[]}>
            {isLoading ? (
                <div className="flex flex-row gap-[22px]">
                    {rangeMap(5, i => (
                        <ProductLoader key={`product_loader_${i}`} uniqueKey={`product-${i}`} />
                    ))}
                </div>
            ) : (
                data?.map((product: any) => {
                    return (
                        <SwiperSlide key={product?.sku} className="py-3">
                            <ProductCard product={product} key={`${product?.sku}`} />
                        </SwiperSlide>
                    );
                })
            )}
        </CustomSwiper>
    );
}

export default ViewedProductsSwiper;
